import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { recursiveFindByCode } from '@src/utils/tree';
import { reportingFormsStore } from '@stores/reportingFormsStore';
import type { PagesParamInterface} from '@stores/reportingFormsStore';
import type { TreeViewInterface } from '@stores/reportingTreeStore/toViewModel';

import type { ConfigMenu } from '../../ReportingForms/ContentMenu/ContentMenu';

export const openInNewTab = async (
  treeData: TreeViewInterface[],
  node: TreeViewInterface,
): Promise<ConfigMenu | undefined> => {
  const { getReportSettings } = reportingFormsStore;

  if (node.reportVersionCode) {
    const config: ConfigMenu = {};

    const nodes = recursiveFindByCode(node.key, treeData);

    if (nodes) {
      config.breadcrumbs = nodes.map((el) => el.title);

      const lastNode = nodes[nodes.length - 1];

      const { reportSettings, valueParametersFromContext } = await getReportSettings(
        node.organizationCode ?? '',
        node.reportVersionCode,
        lastNode,
      );

      if (reportSettings?.url) {
        let params: PagesParamInterface = { ...valueParametersFromContext, typeForm: '' };

        params = {
          title: `${reportSettings.reportCodeExtVersion} - ${reportSettings?.reportVersionName}`,
          reportSettingsUITableSource: reportSettings.uiTableSource,
          reportFilters: [
            [
              {
                name: 'report_package_code_cm',
                type: FILTER.EQ,
                values: [params.reportPackageCode ?? ''],
                filterIsInverted: false,
              },
              {
                name: 'report_version_code_cm',
                type: FILTER.EQ,
                values: [params.reportVersionCode ?? ''],
                filterIsInverted: false,
              },
            ],
          ],
          ...params,
        };

        config.pagesParam = [
          {
            ...params,
            typeForm: reportSettings.url,
            rounded: reportSettings?.rounded,
            organizationCode: reportSettings?.organizationCode,
          },
        ];
        return config;
      }
    }
  }
};
